// extracted by mini-css-extract-plugin
export var body = "ZyXqVzhCm11grb5fY9dk";
export var fontBold = "ZX0hVhqxEgQymNUEXsOQ";
export var fontMedium = "h9aQGwMmrgXLNQI2f5FU";
export var fontRegular = "z8Z_ol3Lv5yiw_3b7zIs";
export var large = "uobp1KoP1S5RyQXsL8qe";
export var micro = "_Ooovh0vMp2BfiF2g9tr";
export var mini = "vPXya0oQ7woyFbqG8d58";
export var root = "vurByGGVTpQEPEGo57Db";
export var small = "ONZb_6HzoUMGtYyy9JjC";